// src/context/BannerContext.jsx
import React, { createContext, useContext, useState } from 'react';

const BannerContext = createContext();

export const useBanner = () => {
  const context = useContext(BannerContext);
  if (!context) {
    throw new Error('useBanner must be used within a BannerProvider');
  }
  return context;
};

export const BannerProvider = ({ children }) => {
  const [banners, setBanners] = useState([]);

  const addBanner = (banner) => {
    const id = Date.now() + Math.random();
    setBanners(prev => [...prev, { ...banner, id }]);
    
    // Auto-remove after delay if specified
    if (banner.autoHide) {
      setTimeout(() => {
        removeBanner(id);
      }, banner.duration || 5000);
    }
  };

  const removeBanner = (id) => {
    setBanners(prev => prev.filter(banner => banner.id !== id));
  };

  const clearBanners = () => {
    setBanners([]);
  };

  return (
    <BannerContext.Provider value={{ banners, addBanner, removeBanner, clearBanners }}>
      {children}
    </BannerContext.Provider>
  );
};